import { Directive, Input, TemplateRef } from '@angular/core';
import { MapElement } from '@shared-features/enums';

@Directive({
  selector: '[appMapElement]',
  exportAs: 'mapElement',
})
export class MapElementDirective {
  type: MapElement;
  @Input() set appMapElement(type: MapElement) {
    this.type = type;
  }
  constructor(public templateRef: TemplateRef<any>) {}
}
